import type { IImpersonationSession } from "~/utils/interfaces/oidc-interfaces";
import { AUTH_REQUIRED_MESSAGE } from "~/utils/helpers/auth/oidc-contract";
import { AuthFlowEnum } from "~/utils/enums/auth.enums";

export function createImpersonationSession(
  accessToken: string,
  targetSubject: string,
  administratorSubject: string,
  administratorGeneration: string,
  administratorFlow = AuthFlowEnum.LEGACY,
): IImpersonationSession {
  if (
    ![accessToken, targetSubject, administratorSubject, administratorGeneration].every(
      (value) => typeof value === "string" && !!value,
    )
  ) {
    throw new Error(AUTH_REQUIRED_MESSAGE);
  }
  return {
    access_token: accessToken,
    targetSubject,
    administratorSubject,
    administratorGeneration,
    administratorFlow,
  };
}
